import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { getInfoCliente } from "../../../../service/AffariService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import LoaderTransparent from '../../../../components/ui/LoaderTransparent';



const TicketsDialog = ({ visible, onCancel, codigo }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && codigo) {
            setLoading(true);
            setData(null);
            getInfoCliente(codigo)
                .then((resp) => setData(resp?.datos ?? resp))
                .catch((error) => {
                    console.error("Error fetching tickets data:", error);
                })
                .finally(() => setLoading(false));
        }
    }, [visible, codigo]);

    const formatCurrency = (value) => {
        const n = typeof value === 'number' ? value : Number(value) || 0;
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n);
    };

    return (
        <Dialog
            header="Tickets promedio"
            visible={visible}
            className="p-fluid custom-dialog"
            modal
            onHide={onCancel}
            dismissableMask={true}
        >
            {loading ? (
                <div className="flex align-items-center justify-content-center h-6rem">
                    <LoaderTransparent coverParent overlayTint="transparent" />
                </div>
            ) : (
                data && (
                    <div className="flex flex-column gap-3">
                        <div className="surface-0 border-1 surface-border border-round p-3">
                            <div className="text-xs text-500 mb-1">Cliente</div>
                            <div className="text-900 font-semibold text-sm">{data.cliente?.codigo} {data.cliente?.rut} {data.cliente?.razonSocial}</div>
                        </div>
                        <div className="surface-0 border-1 surface-border border-round p-2">
                            <DataTable
                                value={[
                                    { periodo: 'Último mes', cantidad: data.ticketsUltimoMes?.cantidad ?? 0, total: data.ticketsUltimoMes?.total ?? 0 },
                                    { periodo: 'Últimos 6 meses', cantidad: data.tickets6Meses?.cantidad ?? 0, total: data.tickets6Meses?.total ?? 0 },
                                    { periodo: 'Últimos 12 meses', cantidad: data.tickets12Meses?.cantidad ?? 0, total: data.tickets12Meses?.total ?? 0 },
                                ].map(r => ({ ...r, promedio: r.cantidad ? r.total / r.cantidad : 0 }))}
                                size="small"
                                className="p-datatable-sm border-0"
                                stripedRows
                            >
                                <Column field="periodo" header="Periodo" />
                                <Column field="cantidad" header="Tickets" />
                                <Column field="total" header="Total" body={(row) => formatCurrency(row.total)} />
                                <Column field="promedio" header="Promedio" body={(row) => formatCurrency(row.promedio)} />
                            </DataTable>
                        </div>
                    </div>
                )
            )}
        </Dialog>
    );
};

export default TicketsDialog;
